import styled from 'styled-components';

import style from '../../style';
import { isAndroid } from '../../utils/devices/device';

export const PreviousButtonWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const NextButtonWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const ChildWrapper = styled.div({
  flexShrink: 0,
});

interface ContentProps {
  $gapBetweenItems: number;
}

export const Content = styled.div<ContentProps>(({ $gapBetweenItems }) => ({
  width: '100%',
  display: 'flex',
  gap: `${$gapBetweenItems}px`,
  overflow: 'auto',

  ...style.mixins.hideScrollbar(),
}));

const getGradient = (left: number, hasReachedEnd: boolean) => {
  const needsLeftGradient = left < 0;
  const needsRightGradient = !hasReachedEnd;

  const gradients: string[] = [];

  if (needsLeftGradient) {
    gradients.push('linear-gradient(to left, black calc(100% - 48px), transparent 100%)');
  }
  if (needsRightGradient) {
    gradients.push(
      'linear-gradient(to right, black calc(100% - 48px), transparent 100%)',
    );
  }

  return gradients.join(', ');
};

interface ContainerProps {
  $left: number;
  $height?: number;
  $hasReachedEnd: boolean;
}

export const Container = styled.div<ContainerProps>(
  ({ $hasReachedEnd, $height, $left }) => ({
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    height: $height ? `${$height}px` : undefined,
    width: '100%',
    background: 'transparent',

    WebkitMaskComposite: $left < 0 ? 'source-in, xor' : 'unset',
    maskComposite: $left < 0 ? 'intersect' : 'unset',

    maskImage: getGradient($left, $hasReachedEnd),
    WebkitMaskImage: isAndroid ? 'none' : getGradient($left, $hasReachedEnd),

    [Content]: {
      position: 'absolute',
    },
  }),
);

export const Wrapper = styled.div({
  display: 'flex',
  flex: 1,
  position: 'relative',

  [PreviousButtonWrapper]: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
  },

  [NextButtonWrapper]: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
  },
});
